import { Moment } from 'moment';
import { ICountryMySuffix } from 'src/app/shared/model/country-my-suffix.model';
import { CountryMySuffixService } from 'src/app/entities/country-my-suffix';
import { ILanguage } from 'src/app/shared/model/language.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IContactDetailDTO {
    // dateOfBirth?: Moment;
    emailAddress?: string;
    id?: number;

    contactNumber?: string;
    internationalCallingCode?: number;
    internationalCallingCodeCountry?: ICountryMySuffix;
    internationalCallingCodeCountryId?: Number;

    isPrimaryContact?: boolean;
    name?: string;
    officeLocation?: string;

    telephoneCode?: number;
    telephoneCodeCountry?: ICountryMySuffix;
    telephoneCodeCountryId?: Number;
    telephoneNumber?: string;

    faxCode?: number;
    faxCodeCountry?: ICountryMySuffix;
    faxCodeCountryId?: Number;
    fax?: string;
    knownLanguages?: ILanguage[];
}

export class ContactDetailDTO implements IContactDetailDTO {
    constructor(
        public contactNumber?: string,
        // public dateOfBirth?: Moment,
        public emailAddress?: string,
        public fax?: string,
        public id?: number,
        public internationalCallingCode?: number,
        public internationalCallingCodeCountry?: ICountryMySuffix,
        public isPrimaryContact?: boolean,
        public name?: string,
        public officeLocation?: string,
        public telephoneCode?: number,
        public telephoneCodeCountry?: ICountryMySuffix,
        public telephoneNumber?: string,
        public faxCode?: number,
        public faxCodeCountry?: ICountryMySuffix,
        public knownLanguages?: ILanguage[]
    ) {}
}
